import styled from "styled-components";

export const ConsoleBatchImportContainer = styled.div`
  max-width: 68.75rem;
  margin: 5rem auto;

  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  padding: 0 1rem 4rem 1rem;
`;

export const ConsoleBatchImportTemplateContent = styled.div`
  display: flex;
  flex-direction: column;

  gap: 1.5rem;

  .header-table {
    display: flex;

    justify-content: space-between;
  }
`;

export const TableTitleImport = styled.p`
  margin: 0;

  font-size: 1rem;
  font-weight: 600;
  line-height: 20px;
`;
